import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [
//商圈首页

{
  path: "/mallArea",
  name: "mallArea",
  component: function component() {
    return import("@/views/mall-area/index.vue");
  },
  meta: {
    title: "商圈",
    foot: false
  }
}];